import script from "./SogCardActionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogCardActionButton.vue?vue&type=script&setup=true&lang=ts"

import "./SogCardActionButton.vue?vue&type=style&index=0&id=67ff74cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ff74cf"]])

export default __exports__